<div class="row page-content">
    <div class="ibox-content pos-relative">
        <div *ngIf="loading == true" class="spinner">
            <div class="sk-spinner sk-spinner-pulse"></div>
        </div>
        <app-content-template-form (onAfterSave)="afterSave($event)"></app-content-template-form>
    </div>
</div>
